import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { public: true },
  },
  {
    path: '/',
    name: 'Layout',
    component: () => import('@/views/Layout.vue'),
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/Dashboard.vue'),
        meta: { title: '首页' },
      },
      {
        path: 'topics',
        name: 'Topics',
        component: () => import('@/views/Topics.vue'),
        meta: { title: '课题管理' },
      },
      {
        path: 'students',
        name: 'Students',
        component: () => import('@/views/Students.vue'),
        meta: { title: '学生管理', teacherOnly: true },
      },
      {
        path: 'documents',
        name: 'Documents',
        component: () => import('@/views/Documents.vue'),
        meta: { title: '文献管理' },
      },
      {
        path: 'search',
        name: 'Search',
        component: () => import('@/views/Search.vue'),
        meta: { title: '语义搜索' },
      },
      {
        path: 'chat',
        name: 'Chat',
        component: () => import('@/views/Chat.vue'),
        meta: { title: 'AI 问答' },
      },
      {
        path: 'submissions',
        name: 'Submissions',
        component: () => import('@/views/Submissions.vue'),
        meta: { title: '学习成果' },
      },
      {
        path: 'messages',
        name: 'Messages',
        component: () => import('@/views/Messages.vue'),
        meta: { title: '消息中心' },
      },
      {
        path: 'zotero',
        name: 'Zotero',
        component: () => import('@/views/Zotero.vue'),
        meta: { title: 'Zotero 集成' },
      },
      {
        path: 'tasks',
        name: 'Tasks',
        component: () => import('@/views/Tasks.vue'),
        meta: { title: '任务管理' },
      },
      {
        path: 'sops',
        name: 'SOPs',
        component: () => import('@/views/SOPs.vue'),
        meta: { title: 'SOP 资料库' },
      },
      {
        path: 'lab',
        name: 'LabResources',
        component: () => import('@/views/LabResources.vue'),
        meta: { title: '实验室资源' },
      },
      {
        path: 'reimbursements',
        name: 'ReimbursementBoard',
        component: () => import('@/views/ReimbursementBoard.vue'),
        meta: { title: '报销看板' },
      },
      {
        path: 'tests',
        name: 'TestRecords',
        component: () => import('@/views/TestRecords.vue'),
        meta: { title: '测试清单' },
      },
      {
        path: 'progress',
        name: 'Progress',
        component: () => import('@/views/Progress.vue'),
        meta: { title: '进度与提醒' },
      },
      {
        path: 'configs',
        name: 'Configs',
        component: () => import('@/views/Configs.vue'),
        meta: { title: '大模型配置', teacherOnly: true },
      },
    ],
  },
  {
    path: '*',
    redirect: '/',
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach((to, from, next) => {
  const token = store.state.token
  const user = store.state.user

  if (!to.meta.public && !token) {
    next('/login')
    return
  }

  if (to.meta.teacherOnly && user && user.role !== 'teacher') {
    next('/')
    return
  }

  next()
})

export default router
